import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/contribFornecedor/';

class FornecedorService{
  constructor(){
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
	}

  findFornecedorByFiltro(idContribuinte, filtro){
    return axios.get(API_URL+'allContribFornecedor?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers});
  }

  getFornecedor(id){
    return axios.get(API_URL+id, {headers: this.headers});
  }

  saveFornecedor(fornecedor){
    return axios.post(API_URL, JSON.stringify(fornecedor), {headers: this.headers});
  }

  removeFornecedor(id){
    return axios.delete(API_URL+id, {headers: this.headers});
  }
}

export default new FornecedorService();